import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';
import type { DrawerID } from 'lumen/services/drawer';

export interface IsDrawerExpandedSignature {
  Args: {
    Positional: [DrawerID];
  };
  Return: boolean;
}

export default class IsDrawerExpandedHelper extends Helper<IsDrawerExpandedSignature> {
  @service declare drawer: Services['drawer'];

  compute([
    drawerId,
  ]: IsDrawerExpandedSignature['Args']['Positional']): IsDrawerExpandedSignature['Return'] {
    return Boolean(this.drawer.isDrawerExpanded(drawerId));
  }
}
